// Turn off while prototyping other features so we don't ping S3 so much
export const SHOW_IMAGES = true;
